import { Button, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle, Input } from '@ibsys/kit';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

type CreateRoleDialogProps = {
  isCreating: boolean;
  onCreateRole: (code: string, name: string) => void;
};

export const CreateRoleDialog: FC<CreateRoleDialogProps> = ({ isCreating, onCreateRole }) => {
  const { t } = useTranslation(['common', 'roles']);

  const [newRoleCode, setNewRoleCode] = useState('');
  const [newRoleName, setNewRoleName] = useState('');

  const handleCreate = () => {
    if (!newRoleCode.trim() || !newRoleName.trim()) return;
    onCreateRole(newRoleCode.trim(), newRoleName.trim());
    setNewRoleCode('');
    setNewRoleName('');
  };

  return (
    <DialogContent className="max-w-80">
      <DialogHeader>
        <DialogTitle>{t('roles:newRole')}</DialogTitle>
      </DialogHeader>
      <div className="flex flex-col gap-4 text-foreground">
        <Input
          value={newRoleCode}
          onChange={(e) => setNewRoleCode(e.target.value)}
          placeholder={t('roles:roleCodePlaceholder')}
          label={t('roles:roleCode')}
        />
        <Input
          value={newRoleName}
          onChange={(e) => setNewRoleName(e.target.value)}
          placeholder={t('roles:roleNamePlaceholder')}
          label={t('roles:roleName')}
        />
      </div>
      <DialogFooter className="flex gap-5">
        <DialogClose>
          <Button variant="ghost">{t('cancel')}</Button>
        </DialogClose>
        <Button onClick={handleCreate} isLoading={isCreating} disabled={!newRoleCode.trim() || !newRoleName.trim()}>
          {t('save')}
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};
